<template>
  <swiper class="swiper" :options="swiperOption">
    <swiper-slide v-for="(item, index) in data" :key="index" class="">
      <a :href="item.adv_url || 'javascript:void(0);'" :target="item.target">
        <img :src="JSON.parse(item.adv_pic)[0].url">
      </a>
    </swiper-slide>
    <!-- <div class="swiper-pagination" slot="pagination"></div> -->
    <div class="swiper-button-prev" slot="button-prev"></div>
    <div class="swiper-button-next" slot="button-next"></div>
  </swiper>
</template>

<script>
  import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
  import 'swiper/css/swiper.css'
  export default {
    name: 'swiper-loop',
    components: {
      Swiper,
      SwiperSlide
    },
    props: {
      data: {
        default: [],
        type: Array
      }
    },
    data() {
      return {
        swiperOption: {
          autoplay: {
            autoplay: true,
            delay: 5000000
          },
          slidesPerView: 'auto',
          centeredSlides: true,
          spaceBetween: 58,
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        }
      }
    }
  }
</script>

<style lang="less" scoped>
.swiper-container {
  width: 100%;
  position: relative;
  overflow: visible;
}
.swiper-slide {
  width: 1446px;
  height: 609px;
  text-align: center;
  img {
    width: 100%;
    height: 100%;
    vertical-align: middle;
    object-fit: cover;
  }
}
.swiper-slide:not(.swiper-slide-active) {
  position: relative;
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9;
    background: rgba(255, 255, 255, 0.6);
  }
}
.swiper-button-prev {
  width: 58px;
  height: 58px;
  background: url('../assets/serve/index/left.png')no-repeat center center;
  background-size: 100% 100%;
  left: 280px;
  right: auto;
  &::after {
    content: '';
  }
}
.swiper-button-next {
  width: 58px;
  height: 58px;
  background: url('../assets/serve/index/right.png')no-repeat center center;
  background-size: 100% 100%;
  right: 280px;
  left: auto;
  &::after {
    content: '';
  }
}
  // @import './base.scss';
</style>